import { SpecificationConfigurationItem, SpecificationsLibrary } from '@grandvisionhq/fun-products'

const commonSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.erpID,
  SpecificationsLibrary.gender,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.roadworthiness,
]

export const frameSpecifications: SpecificationConfigurationItem[] = [
  ...commonSpecifications,
  SpecificationsLibrary.brand,
  SpecificationsLibrary.brandModel,
  SpecificationsLibrary.brandModelCode,
]

export const sunglassesSpecifications: SpecificationConfigurationItem[] = [
  ...commonSpecifications,
  SpecificationsLibrary.brand,
  SpecificationsLibrary.brandModel,
  SpecificationsLibrary.brandModelCode,
  SpecificationsLibrary.glazeble,
  SpecificationsLibrary.polarized,
  SpecificationsLibrary.lensColor,
  SpecificationsLibrary.mirror,
  SpecificationsLibrary.gradient,
]

export const solutionsSpecifications: SpecificationConfigurationItem[] = [
  ...commonSpecifications,
  SpecificationsLibrary.lensTypeTarget,
  SpecificationsLibrary.caseIncluded,
  SpecificationsLibrary.minimumCycleTime,
  SpecificationsLibrary.preservativeFree,
  SpecificationsLibrary.maxTimeFrameInLensCase,
  SpecificationsLibrary.expirationAfterOpening,
  SpecificationsLibrary.packageOption,
]

export const accessorySpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.erpID,
  SpecificationsLibrary.accessoryType,
  SpecificationsLibrary.accessoryColor,
  SpecificationsLibrary.material,
]

export const clSpecifications: SpecificationConfigurationItem[] = [
  ...commonSpecifications,
  SpecificationsLibrary.replacementFrequency,
  SpecificationsLibrary.packageQuantity,
]
